import { render, staticRenderFns } from "./asociar-curso-estudiante.vue?vue&type=template&id=59e3fb65"
import script from "./asociar-curso-estudiante.vue?vue&type=script&lang=js"
export * from "./asociar-curso-estudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports